import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Questions from '../views/Questions';
import Result from '../views/Results';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/question/:id',
        name: 'question',
        component: Questions,
    },
    {
        path: '/results',
        name: 'results',
        component: Result,
    },
    {
        path: '/school/:id',
        name: 'school',
        props: true,
        component: () =>
            import(/* webpackChunkName: 'school' */ '../views/School.vue'),
    },
    {
        path: '/my-schools',
        name: 'MySchools',
        props: true,
        component: () =>
            import(/* webpackChunkName: 'school' */ '../views/MySchools.vue'),
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
});

export default router;
